const proba_redirect_url = process.env.VUE_APP_PROBA_URL || "/";

export default {
  name: "ProbaRedirectButton",

  methods: {
    redirect_to_proba() {
      window.location.href = proba_redirect_url;
    }
  }
};
